export default __webpack_public_path__ + "static/media/player_leave.d0dfd6ce.mp3";